<template>
  <div class="info-card company-card">
    <div class="info-header">
      <slot name="icon">
        <feather-icon
          icon="HomeIcon"
          size="20"
          class="mr-2"
        />
      </slot>
      <h5 class="mb-0">
        {{ headerTitle }}
      </h5>
    </div>
    <div class="info-content">
      <div class="company-name-block">
        <strong class="company-name">{{ company.name }}</strong>
        <span class="info-subtitle">{{ displayTagline }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">Matricule fiscale:</span>
        <span class="info-value info-value--nowrap">{{ displayTaxId }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">Adresse:</span>
        <span class="info-value info-value--break">{{ company.address }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">Téléphone:</span>
        <span class="info-value info-value--nowrap">{{ displayPhone }}</span>
      </div>
      <div
        v-if="showEmail && company.email"
        class="info-item"
      >
        <span class="info-label">Email:</span>
        <span class="info-value info-value--break">{{ company.email }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentCompanyInfo',
  components: {},
  props: {
    company: {
      type: Object,
      required: true,
    },
    headerTitle: {
      type: String,
      default: 'Notre Société',
    },
    maskTaxId: {
      type: Boolean,
      default: false,
    },
    showEmail: {
      type: Boolean,
      default: false,
    },
    showSecondPhone: {
      type: Boolean,
      default: false,
    },
    layout: {
      type: String,
      default: 'horizontal', // 'horizontal' or 'vertical'
      validator: value => ['horizontal', 'vertical'].includes(value),
    },
    customTagline: {
      type: String,
      default: null,
    },
  },
  computed: {
    displayTaxId() {
      if (!this.company.tax_identification_number) return ''
      if (this.maskTaxId) {
        return `***${this.company.tax_identification_number.slice(3)}`
      }
      return this.company.tax_identification_number
    },
    displayTagline() {
      if (this.customTagline) return this.customTagline
      return this.company.tagline || 'Société de livraison des colis'
    },
    displayPhone() {
      if (this.showSecondPhone && this.company.phone2) {
        return `${this.company.phone1} / ${this.company.phone2}`
      }
      return this.company.phone1
    },
  },
}
</script>

<style scoped>
.company-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #eef1f5 100%);
  border-radius: 10px;
  padding: 1.1rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid #e2e8f0;
  border-left: 4px solid #7367f0;
  box-shadow: 0 2px 8px rgba(115, 103, 240, 0.08);
}

.info-header {
  display: flex;
  align-items: center;
  margin-bottom: 0.85rem;
  padding-bottom: 0.6rem;
  border-bottom: 2px solid rgba(115, 103, 240, 0.2);
}

.info-header h5 {
  font-weight: 700;
  color: #7367f0;
  letter-spacing: 0.02em;
}

.info-content {
  font-size: 0.9rem;
  display: block;
}

.company-name-block {
  margin-bottom: 0.5rem;
}

.company-name {
  display: block;
  font-size: 1.05rem;
  font-weight: 700;
  color: #2d2d2d;
  letter-spacing: 0.01em;
}

.info-subtitle {
  display: block;
  font-size: 0.82rem;
  color: #7367f0;
  font-style: italic;
  margin-top: 0.1rem;
}

.info-item {
  display: flex;
  align-items: baseline;
  gap: 0.4rem;
  margin-bottom: 0.4rem;
}

.info-label {
  font-weight: 600;
  color: #495057;
  white-space: nowrap;
  min-width: 110px;
}

.info-value--nowrap {
  white-space: nowrap;
}

.info-value--break {
  word-break: break-word;
}

@media print {
  .company-card {
    background: #fff !important;
    border: 1px solid #000 !important;
    border-left: 4px solid #000 !important;
    box-shadow: none !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .info-header h5 {
    color: #000 !important;
  }
  .info-subtitle {
    color: #000 !important;
  }
  .company-name {
    color: #000 !important;
  }
  .info-label {
    color: #000 !important;
    white-space: nowrap !important;
  }
  .info-value--nowrap {
    white-space: nowrap !important;
  }
}
</style>
